import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { Contingentes } from '../../../../models/contingentes';
import { ContingentesService } from '../../../../services/contingentes.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-contingentes-list',
  templateUrl: './contingentes-list.component.html',
  styleUrls: ['./contingentes-list.component.css']
})
export class ContingentesListComponent implements OnInit
{

  @Input() personalId: number;
  @Input() contingentes: Contingentes[];
  @Input() permisoEdicion: boolean = true;
  @Output() VisualizarDetalle = new EventEmitter<Contingentes>();

  contingentesOri: Contingentes[];
  contingentesGrupo: Contingentes[];
  filtroDesde: string;
  filtroHasta: string;
  agrupar: boolean = false;

  constructor(private contingenteService: ContingentesService,
              private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.contingentesOri = this.contingentes;
    this.inicializaFiltros();
    
    this.filtrarContingentes();
  }

  inicializaFiltros()
  {
    let fechaHoy = new Date();
    let fechaIni = new Date();
    fechaIni.setDate(fechaIni.getDate() - 30);

    let mesString = ('0' + (fechaIni.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    let diaString = ('0' + (fechaIni.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroDesde = (fechaIni.getFullYear()).toString() + "-" + mesString + "-" + diaString ;

    mesString = ('0' + (fechaHoy.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    diaString = ('0' + (fechaHoy.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroHasta = (fechaHoy.getFullYear()).toString() + "-" + mesString + "-" + diaString ;
  }

  filtrarContingentes()
  {
    let desde = moment(this.filtroDesde, "YYYY/MM/DD").toDate();
    let hasta = moment(this.filtroHasta, "YYYY/MM/DD").toDate();
    
    this.contingentes = this.contingentesOri.filter(i => Date.parse(i.desde) <= hasta.getTime() && Date.parse(i.hasta) >= desde.getTime());
  }

  onChangeAgrupamiento()
  {
    //Cambia lista
    if (this.agrupar == true)
    {
      if (this.contingentesGrupo == undefined)
      {
        this.contingenteService.getByPersonal(this.personalId, true).subscribe(
          data =>
          {
            data.forEach((currentValue,index,arr) => {
              currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
              currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
              currentValue.inicioLiquidacion = this.momentService.convertDateServer(currentValue.inicioLiquidacion);
              currentValue.finLiquidacion = this.momentService.convertDateServer(currentValue.finLiquidacion);
            });

            this.contingentesGrupo = data;
            this.contingentes = this.contingentesGrupo;
          });

      } else
      {
        this.contingentes = this.contingentesGrupo;
      }
      
    } else
    {
      this.filtrarContingentes();
    }
  }

  onChangeFiltros()
  {
    this.filtrarContingentes();
  }

  visualizarDetalle(contingente)
  {
    this.VisualizarDetalle.emit(contingente);
  }

  add()
  {
    let contingente: Contingentes = { id: 0, personal: this.personalId, desde: new Date().toString(), hasta: new Date().toString(), claseContingente: 0, inicioLiquidacion: new Date().toString(), finLiquidacion: new Date().toString(), cantidad: 0};
    this.VisualizarDetalle.emit(contingente);
  }
}
